import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { AdminUserList } from '~/features/AdminUserList';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import styles from './styles.module.scss';

/**
 * 企業管理者一覧 Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='企業管理者' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <AdminUserList />
        </Suspense>
      </main>
    </div>
  </div>
);
